/**
 * Canonical report block display names — must match backend BLOCK_CATALOG.
 * 5X-specific labels stay for classic profiles; generic overrides for tenants.
 */
export const REPORT_BLOCK_LABELS = {
  analyzed_company: "Analyzed Company Narrative",
  analyzed_rag: "Survey RAG Evidence",
  analyzed_gemini: "Gemini Briefing",
  analyzed_executive_summary: "Executive Summary",
  analyzed_pillar_charts: "Exact Pillar Charts",
  analyzed_per_pillar: "Per-Pillar Analytics",
  intro_framework: "Introduction & 5x Framework",
  pillar_scores: "Summary: 5x Team Assessment",
  top_priorities: "Highest Importance, Agreement & Overlap",
  opportunity_gaps: "Top Areas for Improvement & Lowest Agreement",
  actionable_recommendations: "Actionable Recommendations",
  variance_analysis: "Key Areas of Difference",
  financial_performance: "Financial Performance & Comments",
  individual_breakdown: "Pillar-by-Pillar Results & Comments",
  team_pillar_rankings: "Team Pillar Rankings & Comments",
};

/** Neutral labels when the workspace assessment format is not classic 5X. */
export const REPORT_BLOCK_LABELS_GENERIC = {
  ...REPORT_BLOCK_LABELS,
  intro_framework: "Introduction & Framework",
  pillar_scores: "Summary: Team Assessment",
  individual_breakdown: "Section-by-Section Results & Comments",
  team_pillar_rankings: "Team Section Rankings & Comments",
  analyzed_pillar_charts: "Section Charts",
  analyzed_per_pillar: "Per-Section Analytics",
};

export function reportBlockLabel(blockId, blockFromApi, { isFiveX = true } = {}) {
  if (blockFromApi?.name) return blockFromApi.name;
  const map = isFiveX ? REPORT_BLOCK_LABELS : REPORT_BLOCK_LABELS_GENERIC;
  return map[blockId] || String(blockId || "").replace(/_/g, " ");
}
